<template>
  <div class="common-code-container">
    <p class="title">{{ title }}</p>
    <p class="description">{{ description }}</p>
    <div v-if="$slots.default" class="common-code-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'commonCode',
  data() {
    return {
      status: false
    }
  },
  created() {
    console.log(this.$slots)
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.common-code-container {
  margin-top: 50px;
  .title {
    margin-bottom: 20px;
    font-size: 22px;
    font-family: OpenSans-Bold, sans-serif;
  }
  .description {
    margin-bottom: 14px;
    font-size: 14px;
    color: #5e6d82;
    font-family: OpenSans, sans-serif;
  }
  .common-code-content {
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
  }
}
</style>
